"use client"

import { useEffect } from "react"

// Client-side replacement for `next/head` page metadata. Restores the previous
// title/description on unmount so navigating between pages doesn't leak titles.
export function AppHead(meta: { title?: string; description?: string }) {
  const { title, description } = meta

  useEffect(() => {
    const prevTitle = document.title
    const descriptionEl = document.querySelector('meta[name="description"]')
    const prevDescription = descriptionEl?.getAttribute("content")

    if (title) document.title = title
    if (description && descriptionEl) descriptionEl.setAttribute("content", description)

    return () => {
      document.title = prevTitle
      if (descriptionEl && prevDescription != null) descriptionEl.setAttribute("content", prevDescription)
    }
  }, [title, description])

  return null
}
